(() => {
  const MQ = window.matchMedia('(min-width: 990px)');
  let closeTimer = null;

  function isDesktop() {
    return MQ.matches;
  }

  function closeAll(exceptDetails = null) {
    document.querySelectorAll('header .header__inline-menu details[open]').forEach(d => {
      if (exceptDetails && d === exceptDetails) return;
      d.removeAttribute('open');
    });
  }

  function bindHover() {
    // Find alle LI i desktopmenuen
    const lis = document.querySelectorAll('header .header__inline-menu li');
    if (!lis.length) return;

    lis.forEach(li => {
      const details = li.querySelector('details');
      if (!details) return;

      li.addEventListener('mouseenter', () => {
        if (!isDesktop()) return;
        if (closeTimer) clearTimeout(closeTimer);

        closeAll(details);
        details.setAttribute('open', '');
      });

      li.addEventListener('mouseleave', (e) => {
        if (!isDesktop()) return;

        // Hvis musen stadig er inde i LI (fx bevægelse mellem elementer), så luk ikke
        if (li.contains(e.relatedTarget)) return;

        if (closeTimer) clearTimeout(closeTimer);
        closeTimer = setTimeout(() => {
          details.removeAttribute('open');
        }, 160);
      });
    });

    // Klik udenfor header lukker (desktop)
    document.addEventListener('mousedown', (e) => {
      if (!isDesktop()) return;
      const header = document.querySelector('header');
      if (header && !header.contains(e.target)) closeAll();
    });
  }

  document.addEventListener('DOMContentLoaded', bindHover);
  document.addEventListener('shopify:section:load', bindHover);
})();